import React from 'react';
import Button from 'react-bootstrap/Button';

function BackButton(props) {
    const {stepNum, updateStep, text, className} = props;
    return (
    <Button className={className ? `back-btn ${className}` : 'back-btn'} onClick={()=> updateStep(stepNum)}>{text}</Button>
    );
  }
  export default BackButton;